import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiDownload, FiMonitor, FiSmartphone, FiArrowDown, FiCheck, FiTv, FiMessageCircle } from 'react-icons/fi';
import './Downloads.css';

const Downloads = () => {
  const [activeTab, setActiveTab] = useState('mobile');

  const desktopFeatures = [
    'Conexão segura e criptografada',
    'Sincronização em nuvem',
    'Histórico detalhado de reprodução',
    'Consumo otimizado de dados',
    'Carregamento rápido',
    'Servidores rápidos e estáveis',
    'Consumo otimizado de dados'
  ];

  const mobileFeatures = [
    'Conexão segura e criptografada',
    'Sincronização em nuvem',
    'Histórico detalhado de reprodução',
    'Consumo otimizado de dados',
    'Carregamento rápido',
    'Servidores rápidos e estáveis',
    'Consumo otimizado de dados'
  ];

  const tvFeatures = [
    'Interface otimizada para controle remoto',
    'Suporte a 4K e HDR',
    'Lista de canais organizada',
    'Guia de programação (EPG)',
    'Troca rápida de canais',
    'Bloqueio parental',
    'Favoritos sincronizados'
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <section id="downloads" className="downloads">
      <div className="downloads-container">
        <motion.div
          className="downloads-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge">Downloads</div>
          <h2 className="section-title">
            Baixe Nosso App
            <span className="gradient-text"> Em Qualquer Dispositivo</span>
          </h2>
          <p className="section-description">
            Aplicativos otimizados para desktop, mobile e TV. Instale agora e comece a assistir em segundos.
          </p>
        </motion.div>

        <div className="mobile-toggle-container">
          <button
            className={`toggle-btn ${activeTab === 'mobile' ? 'active' : ''}`}
            onClick={() => setActiveTab('mobile')}
          >
            <FiSmartphone /> Mobile
          </button>
          <button
            className={`toggle-btn ${activeTab === 'desktop' ? 'active' : ''}`}
            onClick={() => setActiveTab('desktop')}
          >
            <FiMonitor /> PC
          </button>
          <button
            className={`toggle-btn ${activeTab === 'tv' ? 'active' : ''}`}
            onClick={() => setActiveTab('tv')}
          >
            <FiTv /> TV
          </button>
        </div>

        <motion.div
          className="downloads-grid"
          data-active-tab={activeTab}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {/* Desktop App */}
          <motion.div className="download-card desktop-card" variants={cardVariants}>
            <div className="download-card-header">
              <div className="download-icon-wrapper desktop">
                <FiMonitor className="download-icon" />
              </div>
              <div className="download-badge">Windows</div>
            </div>

            <h3 className="download-title">App Desktop</h3>
            <p className="download-subtitle">
              Aplicativo completo para computadores com recursos avançados
            </p>

            <div className="download-features">
              {desktopFeatures.map((feature, index) => (
                <motion.div
                  key={index}
                  className="feature-item"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <FiCheck className="check-icon" />
                  <span>{feature}</span>
                </motion.div>
              ))}
            </div>

            <motion.a
              href="/downloads/windows/CSGTV.exe"
              className="download-btn desktop-btn windows"
              whileHover={{ scale: 1.05, boxShadow: '0 10px 40px rgba(0, 197, 70, 0.4)' }}
              whileTap={{ scale: 0.95 }}
            >
              <FiDownload />
              <span>Baixar para Desktop</span>
              <FiArrowDown />
            </motion.a>

            <div className="download-version-minimal">
              v2.0.1
            </div>
          </motion.div>

          {/* Mobile App */}
          <motion.div className="download-card mobile-card" variants={cardVariants}>
            <div className="download-card-header">
              <div className="download-icon-wrapper mobile">
                <FiSmartphone className="download-icon" />
              </div>
              <div className="download-badge">Android</div>
            </div>

            <h3 className="download-title">App Mobile</h3>
            <p className="download-subtitle">
              Aplicativo otimizado para smartphones e tablets com recursos avançados
            </p>

            <div className="download-features">
              {mobileFeatures.map((feature, index) => (
                <motion.div
                  key={index}
                  className="feature-item"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <FiCheck className="check-icon" />
                  <span>{feature}</span>
                </motion.div>
              ))}
            </div>

            <motion.a
              href="/downloads/android/csgtv.apk"
              className="download-btn mobile-btn android"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FiDownload />
              <span>Baixar para Android</span>
            </motion.a>

            <div className="download-version-minimal">
              v2.0.1
            </div>
          </motion.div>

          {/* TV App */}
          <motion.div className="download-card tv-card" variants={cardVariants}>
            <div className="download-card-header">
              <div className="download-icon-wrapper tv">
                <FiTv className="download-icon" />
              </div>
              <div className="download-badge">Android TV • Smart TV</div>
            </div>

            <h3 className="download-title">App TV</h3>
            <p className="download-subtitle">
              Aplicativo otimizado para televisores inteligentes e Android TV. Consulte o melhor app para sua TV.
            </p>

            <div className="download-features">
              {tvFeatures.map((feature, index) => (
                <motion.div
                  key={index}
                  className="feature-item"
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <FiCheck className="check-icon" />
                  <span>{feature}</span>
                </motion.div>
              ))}
            </div>

            <motion.a
              href="https://wa.me/message/UZEOSUXP7IXTD1"
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn tv-btn"
              whileHover={{ scale: 1.05, boxShadow: '0 10px 40px rgba(139, 92, 246, 0.4)' }}
              whileTap={{ scale: 0.95 }}
            >
              <FiMessageCircle />
              <span>Consultar no WhatsApp</span>
            </motion.a>

            <div className="download-version-minimal">
              Suporte Dedicado
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          className="download-footer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >

        </motion.div>
      </div>
    </section>
  );
};

export default Downloads;

